import React from 'react'
import { motion } from 'framer-motion'
import { HiMail, HiPhone } from 'react-icons/hi'
import logo from '../assets/logo.png'

export default function Footer() {
    return (
        <footer id="contact" className="bg-gradient-to-br from-medical-blue-900 via-medical-blue-800 to-medical-teal-800 text-white">
            {/* Contact Section */}
            <div className="py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="text-center mb-16"
                    >
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                            className="inline-flex items-center justify-center mb-6"
                        >
                            <img
                                src={logo}
                                alt="Alivany Medical & Dental Supplies Logo"
                                className="h-16 md:h-20 w-16 md:w-20 object-contain rounded-full border-4 border-white p-2 bg-white/10 backdrop-blur-sm"
                            />
                        </motion.div>
                        <h2 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h2>
                        <p className="text-xl text-white/90 max-w-2xl mx-auto">
                            Ready to discuss your medical supply needs? Contact us today.
                        </p>
                    </motion.div>

                    <div className="max-w-4xl mx-auto">
                        {/* Contact Info */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="space-y-8"
                        >
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <a
                            href="mailto:info@alivanymedicalsupplies.com"
                                    className="flex items-center space-x-3 sm:space-x-4 p-4 sm:p-6 bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all duration-200 group"
                                >
                                    <div className="p-2 sm:p-3 bg-medical-blue-600 rounded-lg group-hover:scale-110 transition-transform flex-shrink-0">
                                        <HiMail className="w-5 h-5 sm:w-6 sm:h-6" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <div className="text-xs sm:text-sm text-white/70 mb-1">Email</div>
                                        <div className="text-sm sm:text-base md:text-lg font-semibold break-all">info@alivanymedicalsupplies.com</div>
                                    </div>
                                </a>

                                <a
                                    href="tel:+233303955917"
                                    className="flex items-center space-x-3 sm:space-x-4 p-4 sm:p-6 bg-white/10 backdrop-blur-sm rounded-xl hover:bg-white/20 transition-all duration-200 group"
                                >
                                    <div className="p-2 sm:p-3 bg-medical-teal-600 rounded-lg group-hover:scale-110 transition-transform flex-shrink-0">
                                        <HiPhone className="w-5 h-5 sm:w-6 sm:h-6" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <div className="text-xs sm:text-sm text-white/70 mb-1">Phone</div>
                                        <div className="text-sm sm:text-base md:text-lg font-semibold">+233 030 395 5917</div>
                                    </div>
                                </a>
                            </div>

                            <div className="pt-8 border-t border-white/20">
                                <h3 className="text-xl font-semibold mb-4 text-center">Why Choose Alivany?</h3>
                                <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-white/90">
                                    <li className="flex items-start">
                                        <span className="text-medical-teal-400 mr-2">✓</span>
                                        <span>Trusted by 100+ healthcare facilities</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-medical-teal-400 mr-2">✓</span>
                                        <span>International brand partnerships</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-medical-teal-400 mr-2">✓</span>
                                        <span>Comprehensive biomedical engineering services</span>
                                    </li>
                                    <li className="flex items-start">
                                        <span className="text-medical-teal-400 mr-2">✓</span>
                                        <span>Reliable, efficient, and affordable solutions</span>
                                    </li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>
                    </div>
                </div>

            {/* Footer Bottom */}
            <div className="border-t border-white/20 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="text-white/80 text-sm">
                            © {new Date().getFullYear()} Alivany Medical & Dental Supplies Company Limited. All rights reserved.
                        </div>
                        <div className="text-white/80 text-sm">
                            Serving healthcare facilities across Ghana and beyond since 2015
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
